import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      id="top"
      className="sticky top-0 z-50 w-full border-b border-background-300/70 bg-background-50/95 backdrop-blur"
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-secondary-500 text-background-50">
            <i className="ri-hearts-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black text-foreground-950">美丽的小蜜桃</span>
            <span className="mt-0.5 text-[11px] font-medium text-foreground-500">瓜料线索 · 一站式梳理</span>
          </span>
        </a>

        <nav className="hidden items-center gap-0.5 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <label className="flex h-9 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 text-foreground-500">
            <i className="ri-search-line text-base"></i>
            <input
              type="text"
              placeholder="搜索瓜料关键词"
              className="w-36 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400 xl:w-44"
            />
          </label>
          <a
            href="#resources"
            className="flex h-9 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
          >
            <i className="ri-download-2-line text-base"></i>
            资源入口
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
          <div className="mt-3 flex flex-col gap-2">
            <label className="flex h-10 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 text-foreground-500">
              <i className="ri-search-line text-base"></i>
              <input
                type="text"
                placeholder="搜索瓜料关键词"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </label>
            <a
              href="#resources"
              onClick={() => setMenuOpen(false)}
              className="flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-background-50 dark:text-foreground-950 cursor-pointer"
            >
              <i className="ri-download-2-line text-base"></i>
              资源入口
            </a>
          </div>
        </div>
      )}
    </header>
  );
}